module.exports = __webpack_public_path__ + "img/error_tecnico.59221df4.svg";